export default __webpack_public_path__ + "static/media/learn.dca6a181.svg";